import { render } from "./TableHeadRow.vue?vue&type=template&id=b365a9fa&ts=true"
import script from "./TableHeadRow.vue?vue&type=script&lang=ts"
export * from "./TableHeadRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__